<template>
  <b-modal
    :id="'confirm-movement-modal'"
    hide-header
    hide-footer
    centered
    size="sm"
    @show="onShow"
    @hidden="closeModal"
    modal-class="modal-custom"
    no-close-on-backdrop
  >
    <div class="modal-header">
      <div class="modal-title">
        <span>Confirmar movimentação</span>
      </div>
      <span class="icon-close">
        <Close class="stroke" @click="closeModal" />
      </span>
    </div>

    <div class="around-content">
        <b-row class="p-2">
          <b-col class="mt-3" cols="12">
            <p>Confirmando a solicitação de movimentação dos produtos, os status do produto mudam para:</p>
          </b-col>
        </b-row>

        <div class="mt-4">
          <table class="table b-table table-borderless b-table-fixed">
            <thead>
              <tr>
                <th>Status</th>
                <th>Produto</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(productRequest, index) in productRequests" :key="index">
                <td class="status-request">
                  <span :class="'badge badge-pill p-2 ' + productRequest.status">{{ getStatus(productRequest.status) }}</span>
                </td>
                <td>{{ productRequest.product.name }}</td>
              </tr>
            </tbody>
          </table>
      </div>
    </div>

    <div class="wrapper-button text-right mt-5">
      <b-button
        variant="link"
        class="link-disapprove"
        @click="closeModal"
      >
        Cancelar
      </b-button>
      <b-button
        variant="primary"
        size="lg"
        @click="saveForm"
      >
        Confirmar
      </b-button>
    </div>

  </b-modal>
</template>

<script>
import '@/assets/scss/table.scss'
export default {
  components: {
    Close: () => import('@/assets/icons/close.svg'),
  },
  data() {
    return {
    }
  },
  props: {
    productRequests: {
      type: Array,
      default: () => ([])
    },
    refresh: Function
  },
  async mounted() {
    //
  },
  methods: {
    getStatus(status) {
      const arrStatus = {
        entregue: 'Entregue',
        entregue_parcial: 'Entregue Parcial',
        reprovado: 'Reprovado',
        pendente: 'Pendente'
      }

      return arrStatus[status] || '-'
    },
    onShow() {
      //
    },
    closeModal() {
      this.$bvModal.hide('confirm-movement-modal')
    },
    saveForm() {
      console.log("Teste");
    }
  },
}
</script>
<style lang="scss">
#confirm-movement-modal {
  .modal-dialog {
    min-width: 400px;
  }

  .status-request {

    .badge {
      color: #525C7A;
      background-color: #DBFFF0;
      width: 120px;
    }
  }
}
</style>